export interface TipoComentario {
  id: number;
  nome: string;
}


export enum TipoComentarioEnum {
  NORMAL = 1,
  AVALIACAO = 2,
  REABERTURA = 3,
  BOT = 4,
}